import type { ComponentProps } from "react";

import { cn } from "@realroof/ui";

/** Data tables: scroll sideways on phones instead of squeezing. */
export function Table({ className, ...props }: ComponentProps<"table">) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <table className={cn("w-full border-collapse text-left text-[0.9rem]", className)} {...props} />
    </div>
  );
}

export const th = "border-b border-border bg-muted px-3 py-2.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground";
export const td = "border-b border-border px-3 py-2.5 align-top";
